/* ============================================================
 Oakland Sneakers brooklyn-cart.js
 Cart drawer state, Shopify Cart API sync, free-shipping bar,
 combo upsell, toast, scroll reveals.
 Syncs with /cart.js never mutates DOM without updating Shopify.
 ============================================================ */
(function () {
 'use strict';

 var CFG = window.BrooklynConfig || {};
 var THRESHOLD = CFG.freeShippingThreshold || 29900;
 var ROUTES = CFG.routes || {
 cart: '/cart', cartAdd: '/cart/add.js',
 cartChange: '/cart/change.js', cartUpdate: '/cart/update.js'
 };

 /* ---------- Checkout Yampi (domínio próprio) ----------
    A loja roda em brooklynlabx.com.br, mas a Yampi só reconhece o domínio myshopify.
    O script nativo da Yampi manda o host errado e falha ("Merchant not found").
    Aqui interceptamos o botão "Finalizar" (name="checkout"), mandamos o carrinho pra
    Yampi com o shop correto (CFG.yampi.shop) e redirecionamos pra checkout_direct_url.
    Se algo falhar, cai no checkout nativo (/checkout) — o cliente nunca fica sem. */
 function yampiCheckout(btn) {
   var y = CFG.yampi || {};
   if (!y.endpoint || !y.shop) { window.location.href = '/checkout'; return; }
   var original = btn ? btn.textContent : '';
   var done = false;
   function fallback() { if (done) return; done = true; window.location.href = '/checkout'; }
   var timer = setTimeout(fallback, 7000);
   if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Abrindo checkout…'; }
   fetch('/cart.js', { headers: { Accept: 'application/json' } })
     .then(function (r) { return r.json(); })
     .then(function (cart) {
       if (!cart || !cart.item_count) { clearTimeout(timer); done = true; if (btn) btn.textContent = original; return; }
       return fetch(y.endpoint, {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ shop: y.shop, cart_payload: cart })
       })
         .then(function (r) { return r.json(); })
         .then(function (resp) {
           if (done) return;
           if (resp && resp.checkout_direct_url) { done = true; clearTimeout(timer); window.location.href = resp.checkout_direct_url; }
           else { clearTimeout(timer); fallback(); }
         });
     })
     .catch(function () { clearTimeout(timer); fallback(); });
 }
 // Intercepta o clique/submit do botão de finalizar em qualquer página (drawer e /cart)
 document.addEventListener('click', function (e) {
   var btn = e.target.closest && e.target.closest('[name="checkout"]');
   if (!btn || !(CFG.yampi && CFG.yampi.endpoint)) return;
   e.preventDefault(); e.stopPropagation();
   yampiCheckout(btn);
 }, true);
 document.addEventListener('submit', function (e) {
   var f = e.target;
   if (!f || !CFG.yampi || !CFG.yampi.endpoint) return;
   if (f.querySelector && f.querySelector('[name="checkout"]') && (f.getAttribute('action') || '').indexOf('/cart') >= 0) {
     e.preventDefault(); e.stopPropagation();
     yampiCheckout(f.querySelector('[name="checkout"]'));
   }
 }, true);

 /* ---------- DOM refs ---------- */
 var drawer = document.querySelector('[data-cart-drawer]');
 var overlay = document.querySelector('[data-cart-overlay]');
 var itemsEl = document.querySelector('[data-cart-items]');
 var emptyEl = document.querySelector('[data-cart-empty]');
 var footEl = document.querySelector('[data-cart-foot]');
 var totalEl = document.querySelector('[data-cart-total]');
 var comboEl = document.querySelector('[data-cart-combo]');
 var comboMsg = document.querySelector('[data-combo-msg]');
 var comboFill = document.querySelector('[data-combo-fill]');
 var comboCta = document.querySelector('[data-combo-cta]');
 var barEl = document.querySelector('[data-shipping-bar]');
 var barMsg = document.querySelector('[data-shipping-msg]');
 var barFill = document.querySelector('[data-shipping-fill]');
 var suggestEl = document.querySelector('[data-cart-suggest]');
 var suggestRow = document.querySelector('[data-suggest-row]');
 var suggestPrev = document.querySelector('[data-suggest-prev]');
 var suggestNext = document.querySelector('[data-suggest-next]');
 var cashbackEl = document.querySelector('[data-cart-cashback]');
 var subtotalEl = document.querySelector('[data-cart-subtotal]');
 var payParcelado = document.querySelector('[data-pay-parcelado]');
 var payPix = document.querySelector('[data-pay-pix]');
 var titleCountEl = document.querySelector('[data-cart-title-count]');
 var couponEl = document.querySelector('[data-cart-foot-part]');
 var countEls = document.querySelectorAll('[data-cart-count]');

 var suggestLoadedFor = null; // evita re-buscar recomendações à toa
 var suggestProducts = []; // produtos recomendados em cache

 /* ---------- Money formatting (uses shop money_format) ---------- */
 function formatMoney(cents) {
 var fmt = CFG.moneyFormat || 'R${{amount}}';
 var value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
 return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, value);
 }
 window.brooklynFormatMoney = formatMoney;

 /* ---------- Cart API ---------- */
 function getCart() {
 return fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' } })
 .then(function (r) { return r.json(); });
 }

 function changeQuantity(key, quantity) {
 setLoading(true);
 return fetch(ROUTES.cartChange, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify({ id: key, quantity: quantity })
 })
 .then(function (r) { return r.json(); })
 .then(function (cart) { renderCart(cart); return cart; })
 .catch(function () { showToast('Não deu pra atualizar. Tenta de novo.', true); })
 .finally(function () { setLoading(false); });
 }

 function updateCartUI() {
 return getCart().then(renderCart);
 }
 window.updateCartUI = updateCartUI;

 /* ---------- Drawer open/close ---------- */
 function openCartDrawer() {
 if (!drawer) return;
 drawer.classList.add('is-open');
 drawer.setAttribute('aria-hidden', 'false');
 if (overlay) overlay.classList.add('is-open');
 document.body.style.overflow = 'hidden';
 drawer.focus();
 }
 function closeCartDrawer() {
 if (!drawer) return;
 drawer.classList.remove('is-open');
 drawer.setAttribute('aria-hidden', 'true');
 if (overlay) overlay.classList.remove('is-open');
 document.body.style.overflow = '';
 }
 window.openCartDrawer = openCartDrawer;
 window.closeCartDrawer = closeCartDrawer;

 function setLoading(on) {
 if (drawer) drawer.classList.toggle('is-loading', !!on);
 }

 /* ---------- Render ---------- */
 function renderCart(cart) {
 if (!cart) return;
 updateCount(cart.item_count);
 if (titleCountEl) titleCountEl.textContent = '(' + cart.item_count + ')';

 var hasItems = cart.item_count > 0;
 if (emptyEl) emptyEl.hidden = hasItems;
 if (footEl) footEl.hidden = !hasItems;
 if (itemsEl) itemsEl.style.display = hasItems ? '' : 'none';

 if (hasItems && itemsEl) {
 itemsEl.innerHTML = cart.items.map(renderItem).join('');
 } else if (itemsEl) {
 itemsEl.innerHTML = '';
 }

 if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
 renderPromoNudge(cart.item_count);
 renderShippingBar(cart.total_price);
 renderMoneyLines(cart.total_price);
 if (couponEl) couponEl.hidden = cart.item_count === 0;
 renderSuggestions(cart);
 }

 /* ---------- Nudge da promoção PROGRESSIVA (1/99,90 · 2/149,90 · 3/189,90 · 4/229,90) ---------- */
 var promoEl = document.querySelector('[data-cart-promo]');
 var promoMsgEl = document.querySelector('[data-cart-promo-msg]');
 // Preço do combo por quantidade (em centavos). Acima de 4, cada extra +R$40.
 function tierTotal(n) {
 var T = { 1: 9990, 2: 14990, 3: 18990, 4: 22990 };
 if (n <= 0) return 0;
 if (n <= 4) return T[n];
 return 22990 + (n - 4) * 4000;
 }
 function renderPromoNudge(count) {
 if (!promoEl || !promoMsgEl) return;
 if (!count) { promoEl.hidden = true; return; }
 promoEl.hidden = false;
 var atual = tierTotal(count);
 var noun = count > 1 ? 'camisetas' : 'camiseta';
 if (count < 4) {
 promoEl.classList.remove('is-done');
 var prox = tierTotal(count + 1);
 var aMais = prox - atual;
 promoMsgEl.innerHTML =
 'No checkout: <strong>' + count + ' ' + noun + ' por ' + formatMoney(atual) + '</strong>.<br>' +
 'Leve +1 e pague ' + formatMoney(prox) + ' nas ' + (count + 1) + ' camisetas — só ' + formatMoney(aMais) + ' a mais!';
 } else {
 promoEl.classList.add('is-done');
 promoMsgEl.innerHTML =
 'No checkout: <strong>' + count + ' ' + noun + ' por ' + formatMoney(atual) + '</strong>.<br>' +
 'Você está no melhor preço! Cada camiseta extra sai por ' + formatMoney(4000) + '.';
 }
 }

 /* ---------- Barra de progresso do FRETE GRÁTIS ---------- */
 function renderShippingBar(totalCents) {
 if (!barEl) return;
 var remaining = THRESHOLD - totalCents;
 var pct = Math.min(100, (totalCents / THRESHOLD) * 100);
 if (barFill) barFill.style.width = pct + '%';
 if (remaining > 0) {
 barEl.classList.remove('is-complete');
 if (barMsg) barMsg.innerHTML = 'Falta pouco! Mais <strong>' + formatMoney(remaining) + '</strong> e o frete é <strong>GRÁTIS</strong>';
 } else {
 barEl.classList.add('is-complete');
 if (barMsg) barMsg.innerHTML = 'Você garantiu <strong>frete grátis</strong>!';
 }
 }

 /* ---------- Subtotal + cashback + caixas de pagamento ---------- */
 function renderMoneyLines(totalCents) {
 if (cashbackEl) cashbackEl.textContent = formatMoney(Math.round(totalCents * 0.10));
 if (subtotalEl) subtotalEl.textContent = formatMoney(totalCents);
 if (payParcelado) payParcelado.textContent = 'até 6x de ' + formatMoney(Math.round(totalCents / 6));
 if (payPix) payPix.textContent = formatMoney(totalCents);
 }

 /* ---------- Complete seu look (recomendações + Adicionar) ---------- */
 function renderSuggestions(cart) {
 if (!suggestEl || !suggestRow) return;
 if (!cart.items || !cart.items.length) {
 suggestEl.hidden = true;
 suggestLoadedFor = null;
 suggestProducts = [];
 return;
 }
 var baseId = cart.items[0].product_id;
 var inCart = {};
 cart.items.forEach(function (it) { inCart[it.product_id] = true; });

 // já temos os produtos em cache? só refiltra e re-renderiza
 if (suggestLoadedFor === baseId && suggestProducts.length) {
 paintSuggestions(inCart);
 return;
 }
 suggestLoadedFor = baseId;

 var url = '/recommendations/products.json?product_id=' + baseId + '&limit=10&intent=related';
 fetch(url, { headers: { Accept: 'application/json' } })
 .then(function (r) { return r.json(); })
 .then(function (data) {
 suggestProducts = (data && data.products) ? data.products : [];
 paintSuggestions(inCart);
 })
 .catch(function () { suggestEl.hidden = true; });
 }

 function paintSuggestions(inCart) {
 var products = suggestProducts.filter(function (p) { return !inCart[p.id]; }).slice(0, 8);
 if (!products.length) { suggestEl.hidden = true; return; }
 suggestRow.innerHTML = products.map(suggestCard).join('');
 suggestEl.hidden = false;
 }

 function firstAvailableVariant(p) {
 if (!p.variants || !p.variants.length) return null;
 for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i]; }
 return p.variants[0];
 }

 function suggestCard(p) {
 var img = (p.featured_image || (p.images && p.images[0]) || '');
 if (img && img.indexOf('//') === 0) img = 'https:' + img;
 var thumb = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_240x240$1$2') : '';
 var v = firstAvailableVariant(p);
 var multi = p.variants && p.variants.length > 1;

 var priceHtml;
 if (p.compare_at_price && p.compare_at_price > p.price) {
 var off = Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100);
 priceHtml = '<span class="sug__was">' + formatMoney(p.compare_at_price) + '</span>' +
 '<span class="sug__now">' + formatMoney(p.price) + '</span>' +
 '<span class="sug__off">-' + off + '%</span>';
 } else {
 priceHtml = '<span class="sug__now">' + formatMoney(p.price) + '</span>';
 }

 // produto com variações (tamanhos) → manda pra página escolher; senão adiciona direto
 var btn = (v && !multi)
 ? '<button type="button" class="sug__add" data-suggest-add="' + v.id + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 7h12l-1 13H7L6 7Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 7a3 3 0 0 1 6 0" stroke="currentColor" stroke-width="1.6"/></svg> Adicionar</button>'
 : '<a class="sug__add" href="' + p.url + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 7h12l-1 13H7L6 7Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 7a3 3 0 0 1 6 0" stroke="currentColor" stroke-width="1.6"/></svg> Escolher</a>';

 return '<div class="sug">' +
 '<a class="sug__imgwrap" href="' + p.url + '"><img class="sug__img" src="' + thumb + '" alt="' + escapeHtml(p.title) + '" width="120" height="120" loading="lazy"></a>' +
 '<a class="sug__name" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
 '<div class="sug__price">' + priceHtml + '</div>' +
 btn +
 '</div>';
 }

 function addVariant(variantId, btn) {
 var original = btn ? btn.innerHTML : '';
 if (btn) { btn.disabled = true; btn.textContent = 'Adicionando…'; }
 fetch(ROUTES.cartAdd, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify({ id: variantId, quantity: 1 })
 })
 .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
 .then(function () { updateCartUI(); showToast('Adicionado ao carrinho!'); })
 .catch(function () { showToast('Não deu pra adicionar.', true); if (btn) { btn.disabled = false; btn.innerHTML = original; } });
 }

 function renderItem(item) {
 var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
 var variant = (item.variant_title && item.variant_title !== 'Default Title')
 ? '<span class="bk-cart-item__variant">' + escapeHtml(item.variant_title.split(' / ').join(' ')) + '</span>'
 : '';
 return '' +
 '<div class="bk-cart-item" role="listitem">' +
 '<img class="bk-cart-item__img" src="' + img + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">' +
 '<div class="bk-cart-item__body">' +
 '<div class="bk-cart-item__top">' +
 '<p class="bk-cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
 '<button type="button" class="bk-cart-item__remove" data-qty-remove="' + item.key + '">Remover</button>' +
 '</div>' +
 variant +
 '<div class="bk-cart-item__bottom">' +
 '<div class="bk-qty">' +
 '<button type="button" aria-label="Diminuir" data-qty-down="' + item.key + '">−</button>' +
 '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-input="' + item.key + '" aria-label="Quantidade">' +
 '<button type="button" aria-label="Aumentar" data-qty-up="' + item.key + '">+</button>' +
 '</div>' +
 '<span class="bk-cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
 '</div>' +
 '</div>' +
 '</div>';
 }

 function updateCount(count) {
 countEls.forEach(function (el) {
 el.textContent = count;
 el.hidden = count === 0;
 });
 }

 /* ---------- Toast ---------- */
 var toastTimer;
 function showToast(msg, isError) {
 var t = document.createElement('div');
 t.className = 'bk-toast' + (isError ? ' bk-toast--error' : '');
 t.setAttribute('role', 'status');
 t.innerHTML = (isError ? '⚠ ' : '✓ ') + escapeHtml(msg);
 document.body.appendChild(t);
 clearTimeout(toastTimer);
 toastTimer = setTimeout(function () { t.remove(); }, 2600);
 }
 window.brooklynToast = showToast;

 function escapeHtml(s) {
 return String(s == null ? '' : s)
 .replace(/&/g, '&amp;').replace(/</g, '&lt;')
 .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
 }

 /* ---------- Event delegation ---------- */
 document.addEventListener('click', function (e) {
 var addBtn = e.target.closest('[data-suggest-add]');
 if (addBtn) { e.preventDefault(); addVariant(addBtn.getAttribute('data-suggest-add'), addBtn); return; }

 var t = e.target.closest('[data-cart-open],[data-cart-close],[data-qty-up],[data-qty-down],[data-qty-remove]');
 if (!t) return;

 if (t.hasAttribute('data-cart-open')) { e.preventDefault(); openCartDrawer(); updateCartUI(); return; }
 if (t.hasAttribute('data-cart-close')) { closeCartDrawer(); return; }

 var key;
 if ((key = t.getAttribute('data-qty-remove')) != null) { changeQuantity(key, 0); return; }
 if ((key = t.getAttribute('data-qty-up')) != null) {
 var inUp = itemsEl.querySelector('[data-qty-input="' + key + '"]');
 changeQuantity(key, parseInt(inUp.value, 10) + 1); return;
 }
 if ((key = t.getAttribute('data-qty-down')) != null) {
 var inDn = itemsEl.querySelector('[data-qty-input="' + key + '"]');
 changeQuantity(key, Math.max(0, parseInt(inDn.value, 10) - 1)); return;
 }
 });

 document.addEventListener('change', function (e) {
 var input = e.target.closest('[data-qty-input]');
 if (!input) return;
 var key = input.getAttribute('data-qty-input');
 var q = Math.max(0, parseInt(input.value, 10) || 0);
 changeQuantity(key, q);
 });

 if (overlay) overlay.addEventListener('click', closeCartDrawer);
 document.addEventListener('keydown', function (e) {
 if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCartDrawer();
 });

 /* Setas do carrossel "Complete seu look" */
 if (suggestPrev && suggestRow) suggestPrev.addEventListener('click', function () { suggestRow.scrollBy({ left: -180, behavior: 'smooth' }); });
 if (suggestNext && suggestRow) suggestNext.addEventListener('click', function () { suggestRow.scrollBy({ left: 180, behavior: 'smooth' }); });

 /* ---------- Scroll reveal (fade-up) ---------- */
 function initReveals() {
 var els = document.querySelectorAll('.bk-reveal');
 if (!('IntersectionObserver' in window) || !els.length) {
 els.forEach(function (el) { el.classList.add('is-visible'); });
 return;
 }
 var io = new IntersectionObserver(function (entries) {
 entries.forEach(function (en) {
 if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
 });
 }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
 els.forEach(function (el) { io.observe(el); });
 }

 /* ---------- Init ---------- */
 function init() {
 updateCartUI();
 initReveals();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', init);
 } else {
 init();
 }
})();
